<template>
  <ElementsSection :title="$t('home.rooms.title')" :description="$t('home.rooms.description')" data-item="Rooms">
    <Swiper
      :modules="[Navigation]"
      :navigation="{
        prevEl: '[data-carousel-button=rooms][data-carousel-button-prev]',
        nextEl: '[data-carousel-button=rooms][data-carousel-button-next]',
        disabledClass: 'disabled'
      }"
      slides-per-view="auto"
      :space-between="8"
      :breakpoints="{
        640: { slidesPerView: 2, spaceBetween: 16 },
        1024: { slidesPerView: 3, spaceBetween: 20 }
      }"
      class="rooms"
    >
      <SwiperSlide v-for="item in data" :key="item.slug" class="rooms-item select-none">
        <div class="rooms-item__media">
          <ElementsImage v-if="item.images?.[0]?.formats?.large" v-bind="item.images[0].formats.large" />
        </div>
        <div class="rooms-item__content">
          <div class="rooms-item__content-title">{{ item.name }}</div>
          <div class="rooms-item__content-description hidden">{{ item.msquare }} m² {{ $t("rooms.detail.roomSizeLabel") }}</div>
          <NuxtLinkLocale class="rooms-item__content-link" :to="'/rooms/' + item.slug">{{ $t("common.discoverNow") }}</NuxtLinkLocale>
        </div>
      </SwiperSlide>
    </Swiper>

    <template #actions>
      <ElementsCarouselButton name="rooms" />
    </template>
  </ElementsSection>
</template>

<script setup lang="ts">
  import { Swiper, SwiperSlide } from "swiper/vue"
  import { Navigation } from "swiper/modules"
  import "swiper/css"
  import "swiper/css/navigation"

  import fetchApi from "~/utils/fetchApi"

  const { data: responseData } = await useAsyncData("rooms", () =>
    fetchApi<any[]>("rooms", {
      wrappedByKey: "data",
      populate: "*",
      query: {
        sort: ["msquare:asc"]
      }
    })
  )

  const data = computed(() => responseData.value || [])
</script>

<style lang="scss" scoped>
  .rooms {
    @apply overflow-visible;

    &-item {
      @apply flex flex-col relative overflow-hidden transition-opacity duration-200;
      aspect-ratio: 40 / 46;
      max-height: 460px;

      &__media {
        @apply absolute w-full h-full inset-0 relative;

        :deep(img) {
          @apply w-full h-full object-cover;
        }
        &::before {
          @apply content-empty w-full h-full inset-0 absolute z-10;
          background: linear-gradient(0deg, rgba(0, 0, 0, 0.65) 10%, rgba(0, 0, 0, 0) 65%);
        }
      }
      &__content {
        @apply absolute flex flex-col justify-end p-7 z-20 h-full w-full text-white;

        &-title {
          @apply font-display;
          text-shadow: 1px 1px 4px #000;
          font-size: 18px;
          font-weight: 500;
          line-height: 24px;
          letter-spacing: 2px;
          text-transform: uppercase;
          text-wrap: balance;
        }
        &-description {
          text-shadow: 1px 1px 4px #000;
          font-size: 10px;
          font-style: italic;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 1px;
        }
        &-link {
          color: #fff;
          text-shadow: 1px 1px 4px #000;
          font-size: 12px;
          font-weight: 700;
          line-height: 16px;
          letter-spacing: 0.96px;
          text-transform: uppercase;
          text-decoration: underline;
          text-underline-offset: 5px;
          padding-bottom: 5px;
          margin-top: 20px;
        }
      }

      &:not(.swiper-slide-visible) {
        //@apply opacity-60;
      }
    }

    @include media("md") {
      &-item {
        &__content {
          @apply p-4 gap-0.5;

          &-title {
            @apply text-sm font-semibold;
          }
          &-description {
            @apply text-xs;
          }
          &-link {
            font-size: 10px;
            @apply mt-3;
          }
        }
      }
    }
    @include media("sm") {
      &-item {
        width: 80%;
      }
    }
  }
</style>
